import { render, staticRenderFns } from "./rwgaji.vue?vue&type=template&id=85e2a6bc"
import script from "./rwgaji.vue?vue&type=script&lang=js"
export * from "./rwgaji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports